import { render, staticRenderFns } from "./IncomeIndex.vue?vue&type=template&id=6f2acb16"
import script from "./IncomeIndex.vue?vue&type=script&lang=js"
export * from "./IncomeIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports